import { Button } from "@/components/ui/button";

export default function ArtistInbox({
  contactRequests,
  isContactsLoading,
  onMarkRead,
  onOpenThread,
}) {
  return (
    <section className="panel p-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold tracking-tight text-zinc-900 dark:text-zinc-50">
          Inbox
        </h2>
        {isContactsLoading && (
          <span className="text-xs text-zinc-400">Loading…</span>
        )}
      </div>
      {contactRequests.length === 0 ? (
        <p className="mt-2 text-sm text-zinc-500 dark:text-zinc-400">No messages yet.</p>
      ) : (
        <div className="mt-4 grid gap-2">
          {contactRequests.map((c) => (
            <div
              key={c.id}
              className="flex items-start justify-between gap-3 rounded-xl border border-zinc-200/60 bg-white/60 p-4 dark:border-white/[0.07] dark:bg-white/[0.03]"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  {!c.read && (
                    <span className="inline-flex h-1.5 w-1.5 rounded-full bg-amber-500" title="New" />
                  )}
                  <span className="text-sm font-semibold text-zinc-900 dark:text-zinc-100">
                    New inquiry
                  </span>
                  <span className="text-xs text-zinc-400 dark:text-zinc-500">
                    from {c.peer_name || `Venue #${c.venue_id}`}
                  </span>
                </div>
                <p className="mt-1.5 whitespace-pre-line text-sm text-zinc-600 dark:text-zinc-300 line-clamp-3">
                  {c.message}
                </p>
              </div>
              <div className="flex flex-col gap-2 shrink-0">
                <Button
                  type="button"
                  className="btn-secondary text-xs"
                  onClick={() => onOpenThread(c)}
                >
                  Open
                </Button>
                {!c.read && (
                  <Button
                    type="button"
                    className="btn-secondary text-xs"
                    onClick={() => onMarkRead(c.id)}
                  >
                    Mark read
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
